module.exports = __webpack_public_path__ + "static/media/water-desc.5082058a.svg";